"use client";

import { useEffect } from 'react';
import { createVisibleEngagementTimer } from './visible-engagement.mjs';
import { trackEngagedVisit } from './conversions.mjs';

const STORAGE_KEY = 'celestial:active-visit-ms:v1';
let fallbackElapsed = 0;

function readElapsed() {
  try {
    return Math.max(fallbackElapsed, Number(sessionStorage.getItem(STORAGE_KEY)) || 0);
  } catch {
    return fallbackElapsed;
  }
}

function saveElapsed(value) {
  fallbackElapsed = value;
  try { sessionStorage.setItem(STORAGE_KEY, String(value)); } catch { /* Storage may be blocked. */ }
}

export default function EngagedVisitTracking() {
  useEffect(() => {
    const initialElapsed = readElapsed();
    if (initialElapsed >= 10000) return;
    const timer = createVisibleEngagementTimer({
      initialElapsed,
      onProgress: saveElapsed,
      onComplete: trackEngagedVisit,
    });
    const visibilityChanged = () => timer.setVisible(document.visibilityState === 'visible');
    const pageHidden = () => timer.setVisible(false);
    document.addEventListener('visibilitychange', visibilityChanged);
    window.addEventListener('pagehide', pageHidden);
    window.addEventListener('pageshow', visibilityChanged);
    visibilityChanged();
    return () => {
      document.removeEventListener('visibilitychange', visibilityChanged);
      window.removeEventListener('pagehide', pageHidden);
      window.removeEventListener('pageshow', visibilityChanged);
      pageHidden();
    };
  }, []);
  return null;
}
